import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Switch, FormControlLabel, Button, Stack, Alert } from '@mui/material';
import apiClient from '../../services/api';

const AdminSettings = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  const [maintenance, setMaintenance] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const resp = await apiClient.getMaintenanceStatus();
        if (mounted && resp?.success) setMaintenance(Boolean(resp.data?.maintenance));
      } catch (e) {
        setError(e.message);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  const handleSave = async () => {
    setSaved(false);
    setError('');
    try {
      const resp = await apiClient.setMaintenanceStatus(maintenance);
      if (!resp?.success) throw new Error(resp?.error || 'Failed to save');
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 700 }}>Settings</Typography>
      <Paper sx={{ p: 3 }}>
        <Stack spacing={2}>
          {error && <Alert severity="error">{error}</Alert>}
          {saved && <Alert severity="success">Saved</Alert>}
          <FormControlLabel
            control={<Switch checked={maintenance} onChange={e => setMaintenance(e.target.checked)} />}
            label="Maintenance Mode"
          />
          <Typography variant="body2" color="text.secondary">
            When enabled, public users will see the maintenance page.
          </Typography>
          <Box>
            <Button variant="contained" disabled={loading} onClick={handleSave}>Save</Button>
          </Box>
        </Stack>
      </Paper>
    </Box>
  );
};

export default AdminSettings;




